import { CVExplainer } from '../components/cv/CVExplainer'

export default function Test() {
  return <CVExplainer />
}
